import React, { useEffect, useState } from 'react';
import { useSearchParams, Navigate } from 'react-router-dom';
import authService from '../../services/AuthService';
import EmployeePacket from '../Application/EmployeePacket';

const ProtectedI9Form: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuthorization = () => {
      try {
        const queryToken = searchParams.get('token');
        const applicationId = searchParams.get('applicationId');
        const authorized = authService.isAuthorizedForI9Form(queryToken || undefined, applicationId || undefined);
        setIsAuthorized(authorized);
      } catch (error) {
        console.error('Authorization check failed:', error);
        setIsAuthorized(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuthorization();
  }, [searchParams]);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!isAuthorized) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <EmployeePacket />;
};

export default ProtectedI9Form;
